import { callAjax } from '../../../assets/js/helpers'
import debounce from 'lodash/debounce'
import PaginationAjax from '../../pagination/PaginationAjax'

class FiltersQuery {
  form: HTMLFormElement
  loader: HTMLElement
  postsContainer: HTMLElement
  totalPostsCountContainer: HTMLElement
  paginationContainer: HTMLElement | undefined

  constructor(form: HTMLFormElement) {
    this.form = form
    this.postsContainer = document.getElementById('filtered-posts') as HTMLElement
    this.totalPostsCountContainer = document.querySelector('.filtered-posts-count__value') as HTMLElement
    this.loader = document.querySelector('.filtered-posts-container__loader') as HTMLElement
  }

  public async getPosts(additionalQuery?: { [key: string]: string }) {
    if (!this.postsContainer) return

    const formData = new FormData(this.form)

    formData.append('action', 'FilterPostsAjax')

    if (document.body.classList.contains('page-template-page-favourites')) {
      formData.append('is_favourites', '1')
    }

    if (additionalQuery) {
      for (const [key, value] of Object.entries(additionalQuery)) {
        formData.append(key, value)
      }
    }

    this.form.classList.add('is-loaded')
    this.postsContainer.innerHTML = ''

    return callAjax({
      method: 'POST',
      body: formData,
    })
      .then(res => res.json())
      .then(res => {
        this.postsContainer.innerHTML = res.html
        this.totalPostsCountContainer.innerHTML = res.total_posts
        this.paginationContainer = document.querySelector('.filtered-posts__pagination') as HTMLElement
        this.paginationContainer.innerHTML = res.pagination
        new PaginationAjax(this.paginationContainer).handleClick(e => this.getPosts({ paged: `${e.pageNumber}` }))
        this.form.classList.remove('is-loaded')
      })
  }

  public onInputChange(cb: () => Promise<void>) {
    const inputs = this.form.querySelectorAll('input.query-filter')
    const selects = this.form.querySelectorAll('select.query-filter')

    inputs.forEach(input => {
      input.addEventListener(
        'change',
        debounce(() => {
          cb()
          this.setUrl()
        }, 300),
      )
    })

    selects.forEach(select => {
      select.addEventListener(
        'change',
        debounce(() => {
          cb()
          this.setUrl()
        }, 300),
      )
    })

    return this
  }

  /**
   * Append params to url
   * @returns
   */
  private setUrl() {
    const formData = new FormData(this.form)

    // @ts-ignore
    const urlParams = new URLSearchParams(formData).toString()
    const new_url = '?' + urlParams
    window.history.pushState('data', document.title, new_url)

    const searchButton = this.form.querySelector('.js-search-yachts-button') as HTMLElement
    if (searchButton) {
      const currentHref = searchButton.getAttribute('href')
      searchButton.setAttribute('href', currentHref + new_url)
    }

    return this
  }
}

export default FiltersQuery
